import { render, staticRenderFns } from "./AddAgent.vue?vue&type=template&id=f520bed0&"
import script from "./AddAgent.vue?vue&type=script&lang=js&"
export * from "./AddAgent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports